import {apiService} from '../apiService';

export const paymentsService = apiService.injectEndpoints({
    endpoints: (builder) =>
        ({
            getStripeConnectionStatus: builder.query({
                query: () => ({
                    url: '/integrations/stripe/status'
                }),
            }),
            createStripeOnboardingLink: builder.mutation({
                query: () => ({
                    url: '/integrations/stripe/connect',
                    method: 'POST',
                })
            }),
            createStripeAccountLink: builder.mutation({
                query: () => ({
                    url: '/integrations/stripe/link',
                    method: 'POST',
                })
            }),
            disconnectStripeAccount: builder.mutation({
                query: () => ({
                    url: '/integrations/stripe/disconnect',
                    method: 'POST',
                })
            }),

            createFormPaymentIntent: builder.mutation({
                query: ({formRequestId, fieldId, returnPath}) => ({
                    url: `/payments/form-requests/${formRequestId}/fields/${encodeURIComponent(fieldId)}/intent`,
                    method: 'POST',
                    data: {returnPath},
                })
            }),
            verifyFormPaymentSession: builder.mutation({
                query: ({formRequestId, sessionId}) => ({
                    url: `/payments/form-requests/${formRequestId}/verify-session`,
                    method: 'POST',
                    data: {sessionId},
                })
            }),
            getFormFieldPaymentStatus: builder.query({
                query: ({formRequestId, fieldId}) => ({
                    url: `/payments/form-requests/${formRequestId}/fields/${encodeURIComponent(fieldId)}/status`
                }),
            }),
            getFormPaymentStatus: builder.query({
                query: ({formRequestId, paymentRequestId}) => ({
                    url: `/payments/form-requests/${formRequestId}/payments/${paymentRequestId}/status`
                }),
            }),

            getPaymentRequests: builder.query({
                query: (take = 200) => ({
                    url: '/payments/requests',
                    params: {take},
                }),
            }),
            getCardPayments: builder.query({
                query: (limit = 100) => ({
                    url: '/payments/card-payments',
                    params: {limit},
                }),
            }),
            getFormFieldPayment: builder.query({
                query: ({formRequestId, fieldId}) => ({
                    url: `/payments/form-requests/${formRequestId}/fields/${encodeURIComponent(fieldId)}/payment`
                }),
            }),
            refundPayment: builder.mutation({
                query: ({paymentRequestId, amountPence}) => ({
                    url: `/payments/requests/${paymentRequestId}/refund`,
                    method: 'POST',
                    data: {amountPence},
                })
            }),
        })
});

export const {
    useGetStripeConnectionStatusQuery,
    useCreateStripeOnboardingLinkMutation,
    useCreateStripeAccountLinkMutation,
    useDisconnectStripeAccountMutation,
    useCreateFormPaymentIntentMutation,
    useVerifyFormPaymentSessionMutation,
    useGetFormFieldPaymentStatusQuery,
    useGetFormPaymentStatusQuery,
    useGetPaymentRequestsQuery,
    useGetCardPaymentsQuery,
    useGetFormFieldPaymentQuery,
    useRefundPaymentMutation,
} = paymentsService;
